import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=ff86803c"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=ff86803c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports